// Astro's ClientRouter swaps in new HTML without re-running the modules already
// in memory. Navigate after a deploy and the previous bundle's Alpine ends up
// driving markup from the new one: its components were never registered there,
// so every x-data resolves to undefined and bindings wipe the attributes they
// were meant to set. Vercel's skew protection keeps the old chunks fetchable,
// so this fails silently rather than 404ing, which is why it reads as a random
// glitch. One hard load puts the page and its JS back on the same deployment.

const RELOAD_KEY = 'enovate.build-reload';

const servedBuildId = (doc = document) =>
    doc.querySelector('meta[name="build-id"]')?.getAttribute('content') ?? null;

const reloadOnce = (served, to) => {
    if (!served || !__BUILD_ID__ || served === __BUILD_ID__) return;

    // A mismatch that somehow survives the reload would otherwise loop forever,
    // which is a worse failure than the one being fixed.
    try {
        if (sessionStorage.getItem(RELOAD_KEY) === served) return;
        sessionStorage.setItem(RELOAD_KEY, served);
    } catch (e) {
        return;
    }

    window.location.assign(to ?? window.location.href);
};

// The new document is in hand before the swap, so the stale bundle never gets
// to render against it.
document.addEventListener('astro:before-swap', (event) => {
    reloadOnce(servedBuildId(event.newDocument), event.to);
});

// Safety net for any route into a swapped page that skips the above.
document.addEventListener('astro:page-load', () => reloadOnce(servedBuildId()));
